// Restrictable admin pages — the frontend mirror of backend/utils/page_access.py.
// Keep the `key` values identical in both files; the backend is the enforcing copy,
// this one drives the nav, the route guards and the Team page's toggles.
//
// Dashboard and My Profile are always visible. Team and Notifications are absent on
// purpose: they stay super-admin-only, gated by role rather than by page access.
// `navLabel` is the shorter form used in the compact money nav; `icon` is its emoji.
export const PAGES = [
  { key: 'clients', label: 'Clients', group: 'Work', path: '/admin/clients', icon: '👥' },
  { key: 'pipeline', label: 'Pipeline', group: 'Work', path: '/admin/pipeline', icon: '🎯' },
  { key: 'projects', label: 'Projects', group: 'Work', path: '/admin/projects', icon: '📁' },
  { key: 'time', label: 'Time Tracking', group: 'Work', path: '/admin/time', icon: '⏱️' },
  { key: 'invoices', label: 'Invoices', group: 'Work', path: '/admin/invoices', icon: '🧾' },
  { key: 'scope', label: 'Scope of Work', group: 'Work', path: '/admin/scope', icon: '📄' },
  { key: 'ideas', label: 'Ideas', group: 'Work', path: '/admin/ideas', icon: '💡' },
  { key: 'debt', label: 'Debt Tracker', group: 'Money', path: '/admin/debt', icon: '📉' },
  { key: 'wealth', label: 'Wealth', group: 'Money', path: '/admin/wealth', icon: '💎' },
  { key: 'budget', label: 'Budget', group: 'Money', path: '/admin/budget', icon: '📊' },
  { key: 'subscriptions', label: 'Subscriptions', group: 'Money', path: '/admin/subscriptions', icon: '🔁' },
  { key: 'calculator', label: 'Calculator & Homes', navLabel: 'Calculator', group: 'Money', path: '/admin/calculator', icon: '🧮' },
  { key: 'insurance', label: 'Insurance', group: 'Money', path: '/admin/insurance', icon: '🛡️' },
  { key: 'balances', label: 'Balances', group: 'Money', path: '/admin/balances', icon: '💳' },
  { key: 'assistant', label: 'Assistant', group: 'Assistant', path: '/admin/assistant', icon: '🗂️' },
];

export const ALL_PAGE_KEYS = PAGES.map((p) => p.key);

export const PAGE_GROUPS = ['Work', 'Money', 'Assistant'];

export const pagesInGroup = (group) => PAGES.filter((p) => p.group === group);

export const pageLabel = (key) => (PAGES.find((p) => p.key === key) || {}).label || key;

export default PAGES;
